import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../component/Global/Modal";
import { useBOMStore } from "../../../hooks/bom";
import {
    export_type as export_type_reducer,
    load_all_selected_fields,
    remove_all_selected_fields,
    save_preference as save_preference_reducer,
    toggle_single_selected_fields
} from "../../../store/slice/model/BOM/BOMDownloadPopup";
import System from "../../../helper/system";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import Helper from 'src/support/Helper';
import { SET_DOWNLOAD_LOADER } from 'src/store/slice/model/BOMProject';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from 'src/support/Constants';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMProjectStore } from "src/hooks/bom_project";
import { Tooltip } from 'src/component/Tooltip';

const DownloadBomPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [bomData, SetBomData] = useState({});
    const [status, SetStatus] = useState(false);
    const [recipientEmail, setRecipientEmail] = useState('');
    const [recipientEmailError, setRecipientEmailError] = useState('');
    const [senderEmail, setSenderEmail] = useState('');
    const [senderEmailError, setSenderEmailError] = useState('');
    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState('');
    const dispatch = useDispatch(false);
    const [{ DownloadBomPopup }, { }, { }] = useDOMAttachToSystemStore();
    const selected_fields = useSelector((state) => state.entities.model_BOM_BOMDownloadPopup.selected_fields)
    const export_type = useSelector((state) => state.entities.model_BOM_BOMDownloadPopup.export_type)
    const save_preference = useSelector((state) => state.entities.model_BOM_BOMDownloadPopup.save_preference)
    const [{ bom_detail_by_bom_id_type, bom_detail_by_bom_id }, { get_bom_detail_by_bom_id_with_type, get_bom_detail_by_bom_id, fetch_download_file_preference }, { bom_download_file, bom_email_file }] = useBOMStore();
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    useEffect(() => {
        async function f() {
            if (DownloadBomPopup) {
                if (DownloadBomPopup.data.single_bom !== undefined) {
                    SetBomData(DownloadBomPopup.data.single_bom)
                    await get_bom_detail_by_bom_id_with_type({
                        bomId: DownloadBomPopup.data.single_bom.bomId,
                        matchType: 'Exact',
                        callFrom: 'Download'
                    })
                    await get_bom_detail_by_bom_id({
                        bomId: DownloadBomPopup.data.single_bom.bomId,
                        callFrom: 'Download'
                    })
                }
                await fetch_download_file_preference()
                dispatch(export_type_reducer({ export_type: 'xlsx' }))
                if (DownloadBomPopup.data.manageLoad) {
                    dispatch(SET_DOWNLOAD_LOADER({ bomId: DownloadBomPopup.data.single_bom.bomId, isLoad: false, projectId: DownloadBomPopup.data.projectId }));
                }
                SetStatus(true)
            }
        }

        f()
    }, [DownloadBomPopup]);

    /**
     * Bug    #  : 9670
     * Change #  : Display download message on download
     * Change by : PN
     * Date      : 4 Aug 2023 
     */
    const showDownloadMessage = (fileDetails) => {
        System.alert(Constants.downloadMsg, 'success', 'downloadBOM');
        downloadComplete(fileDetails);
    }

    //By Ramya Kannan [Bom-dowmload ]
    async function downloadComplete(dwdDetails) {
        let dwdBOM = bom_detail_by_bom_id || DownloadBomPopup?.data?.single_bom;
        dwdDetails.fileName = dwdBOM.bomName;
        dwdDetails.dwdType = "BOM";
        let bomDetails = {
            bomId: dwdBOM.bomId || dwdDetails.bomId,
            bomName: dwdBOM.bomName,
            newBOM: dwdBOM.newBOM,
            source: dwdBOM.source,
            exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
            nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
            multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
        };
        if (bom_project_list) {
            bomDetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
        }
        localStorage.setItem("adobeEventType", "miBomDownload");
        if (Object.keys(dwdDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ dwdDetails, bomDetails });
        }
    }
    //By Ramya Kannan [Email-Bom ]
    function emailBOMEvent() {
        let emailBOMDts = bom_detail_by_bom_id;
        let emailBomdetails = {
            bomId: emailBOMDts.bomId,
            bomName: emailBOMDts.bomName,
            newBOM: emailBOMDts.newBOM,
            source: emailBOMDts.source,
            exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
            nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
            multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
        };
        if (bom_project_list) {
            emailBomdetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
        }
        localStorage.setItem("adobeEventType", "emailBOMEvent");
        if (Object.keys(emailBomdetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ emailBomdetails });
        }
    }

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const downloadFile = async (isEmailPopup = true) => {
        let error = false
        if (isEmailPopup === 'yes') {
            if (recipientEmail.trim().length === 0) {
                setRecipientEmailError("Recipient email is required");
                error = true;
            }
            if (!recipientEmail.match(emailRegex)) {
                setRecipientEmailError("Enter valid recipient email");
                error = true;
            }
            if (senderEmail && !senderEmail.match(emailRegex)) {
                setSenderEmailError("Enter valid sender email");
                error = true;
            }
            if (message.length > 1000) {
                setMessageError("Max 1000 character allowed");
                error = true;
            }
        }

        if (!error) {
            let f = [];
            Object.entries(selected_fields).map((v) => {
                f.push(v[1].fileColumnName);
            });
            let params = {
                bomId: System.getParams().bomId ? System.getParams().bomId : bomData.bomId,
                fileType: export_type,
                save_preference: save_preference,
                fieldColumns: f,
                currentCurrency: Helper.getCurrentCurrency()
            };

            let result = '';
            if (isEmailPopup === 'yes') {
                if (senderEmail.trim().length > 0) {
                    params.senderEmail = senderEmail
                }
                if (recipientEmail.trim().length > 0) {
                    params.recipientEmail = recipientEmail
                }
                if (message.trim().length > 0) {
                    params.message = message
                }
                result = await bom_email_file(
                    params
                );

            } else {
                result = await bom_download_file(
                    params
                );
            }
            if (result?.payload) {
                let fileDetails = result?.meta?.arg;
                if (!(isEmailPopup === 'yes')) {
                    setTimeout(() => {
                        showDownloadMessage(fileDetails);
                    }, 50);
                }
                else {
                    emailBOMEvent(fileDetails);
                }
            }
            SetStatus(false);
        }

    };

    const setStatusOfForFieldActivated = (singleDownloadColumnList) => {
        dispatch(toggle_single_selected_fields({ ...singleDownloadColumnList }))
    };

    const setAllStatusOfForFieldActivated = () => {
        if (bom_detail_by_bom_id_type.downloadColumnList && Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length > 0) {
            dispatch(load_all_selected_fields({ selected_fields: bom_detail_by_bom_id_type.downloadColumnList }))
        }
    };

    const getStatusOfForFieldActivated = (singleDownloadColumnList) => {
        if (selected_fields && selected_fields[singleDownloadColumnList.columnName] !== undefined
        ) {
            return selected_fields[singleDownloadColumnList.columnName];
        }
        return false
    };

    const onRecipientEmailChange = (value) => {
        if (value.length === 0) {
            setRecipientEmailError("recipient email is required");
        } else if (!value.match(emailRegex)) {
            setRecipientEmailError("Enter valid recipient email");
        } else {
            setRecipientEmailError("");
        }
        setRecipientEmail(value)
    }

    const onSenderEmailChange = (value) => {
        if (emailRegex && !value.match(emailRegex)) {
            setSenderEmailError("Enter valid sender email");
        } else {
            setSenderEmailError("");
        }
        setSenderEmail(value)
    }

    const onMessageChange = (value) => {
        if (value.length > 1000) {
            setMessageError("Max 1000 character allowed");
        } else {
            setMessageError("");
        }
        setMessage(value)
    }
    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal modal-630">
                    {bom_detail_by_bom_id_type.downloadColumnList !== undefined &&
                        <div className="avnet-modal-inner">
                            {/* Modal Header */}
                            {Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length !== undefined &&
                                <>
                                    <button type="button" className="close py-3" data-dismiss="modal"
                                        onClick={() => {
                                            onHide()
                                        }}>×
                                    </button>
                                    <div className="modal-header text-center">
                                        <h3 className="pcn-modal-heading">
                                            {DownloadBomPopup && DownloadBomPopup.data && DownloadBomPopup.data.isEmailPopup === 'yes' &&
                                                <>
                                                    Email
                                                </>
                                            }{!(DownloadBomPopup && DownloadBomPopup.data && DownloadBomPopup.data.isEmailPopup === 'yes') &&
                                                <>
                                                    Download
                                                </>
                                            } BOM</h3>
                                    </div>
                                </>
                            }
                            {/* Modal body */}
                            <div className="modal-body">
                                {Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length === undefined &&
                                    <div className="text-center">
                                        <button className="bs5 m-t-30 mb-3 btn btn-secondary w155">Data not Found</button>
                                    </div>
                                }
                                {Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length !== undefined &&
                                    <>
                                        <div className="light-card m-b-10">
                                            <div className="light-card-header">
                                                <div className="light-card-title">
                                                    Select file type to export. <span className="font-normal">(required)</span>
                                                </div>
                                            </div>
                                            <div className="light-card-body pb-0">
                                                <div className="form-check-inline">
                                                    <div className="form-check form-check-inline pr-5 pb-3">
                                                        <input type="radio" className="form-check-input font-14"
                                                            id="customRadio"
                                                            value="csv"
                                                            checked={!export_type ? true : false || export_type === "csv"}
                                                            onChange={(e) => {
                                                                dispatch(export_type_reducer({ export_type: e.target.value }))
                                                            }}
                                                        />
                                                        <label className="form-check-label mt-0"
                                                            htmlFor="customRadio">CSV</label>
                                                    </div>
                                                    <div className="form-check form-check-inline pr-5 pb-3">
                                                        <input type="radio" className="form-check-input font-14"
                                                            id="customRadio2"
                                                            onChange={(e) => {
                                                                dispatch(export_type_reducer({ export_type: e.target.value }))
                                                            }}
                                                            value="xlsx"
                                                            checked={export_type === "xlsx"}
                                                            name="example" defaultValue="customEx" />
                                                        <label className="form-check-label mt-0"
                                                            htmlFor="customRadio2">XLSX</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="light-card m-b-15">
                                            <div className="light-card-header">
                                                <div className="light-card-title">
                                                    All checked columns will be exported. Part number will be included by
                                                    default.
                                                </div>
                                            </div>
                                            <div className="light-card-body pb-0">
                                                <div className="mb-3">
                                                    <a className='text-blue2 me-1' href={void (0)} onClick={() => {
                                                        setAllStatusOfForFieldActivated()
                                                    }}>Select All</a>
                                                    l
                                                    <a className='text-blue2 ms-1' href={void (0)} onClick={() => {
                                                        dispatch(remove_all_selected_fields())
                                                    }}>Clear All</a>
                                                </div>
                                                <ul className="three-col pl-0 m-b-10">
                                                    {bom_detail_by_bom_id_type.downloadColumnList && Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length > 0 &&
                                                        Object.entries(bom_detail_by_bom_id_type.downloadColumnList).map((v) => (
                                                            <li key={v[1].columnName}>
                                                                <div className="form-check m-b-10">
                                                                    {v[1].columnName === 'requestedPartNumber' &&
                                                                        <input type="checkbox" className="form-check-input font-14"
                                                                            checked={true}
                                                                            disabled={true}
                                                                            readOnly={true}
                                                                            id={'checkBox' + v[1].columnName}
                                                                            name={'checkBox' + v[1].columnName} />
                                                                    }
                                                                    {v[1].columnName !== 'requestedPartNumber' &&
                                                                        <input type="checkbox" className="form-check-input font-14"
                                                                            checked={getStatusOfForFieldActivated(v[1])}
                                                                            onChange={(e) => {
                                                                                setStatusOfForFieldActivated(v[1])
                                                                            }}
                                                                            id={'checkBox' + v[1].columnName}
                                                                            name={'checkBox' + v[1].columnName} />
                                                                    }

                                                                    <>
                                                                        {['eRPManufacturerPartNumber', 'eRPManufacturerName', 'eRPManufacturerCode'].includes(v[1]?.columnName) && DownloadBomPopup.data.isEmailPopup !== 'yes' ?
                                                                            <Tooltip
                                                                                opener={() => (
                                                                                    <label className="form-check-label mt-0 font-13 "
                                                                                        onChange={(e) => {
                                                                                            setStatusOfForFieldActivated(v[1])
                                                                                        }}
                                                                                        htmlFor={'checkBox' + v[1].columnName}>{v[1].fileColumnName}
                                                                                    </label>
                                                                                )}
                                                                                content={() => (
                                                                                    <>
                                                                                        {v[1].fileColumnName + ' as provide by regional ERP'}
                                                                                    </>
                                                                                )}
                                                                            />
                                                                            :
                                                                            <label className="form-check-label mt-0 font-13 "
                                                                                onChange={(e) => {
                                                                                    setStatusOfForFieldActivated(v[1])
                                                                                }}
                                                                                htmlFor={'checkBox' + v[1].columnName}>{v[1].fileColumnName}
                                                                            </label>
                                                                        }
                                                                    </>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="save-prefrence mt-4">
                                            <div className="col-12">
                                                <div className="form-check m-b-15">
                                                    <input type="checkbox" className="form-check-input font-14"
                                                        id="save_preference"
                                                        name="save_preference"
                                                        value="yes"
                                                        checked={save_preference === "yes"}
                                                        onClick={(e) => {
                                                            dispatch(save_preference_reducer({ save_preference: e.target.value }))
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="save_preference">Save my
                                                        selection
                                                        preference</label>
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            DownloadBomPopup && DownloadBomPopup.data && DownloadBomPopup.data.isEmailPopup === 'yes' &&
                                            <div className="bs5 row gx-2">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="email" className="form-label">Recipient Email*</label>
                                                        <input type="text" className="form-control form-control-sm"
                                                            id="recipientEmail" placeholder="Email address"
                                                            name="recipientEmail"
                                                            onChange={(e) => onRecipientEmailChange(e.target.value)} />

                                                        <p className='error'>{recipientEmailError.length > 0 && recipientEmailError}</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="email" className="form-label">Sender (optional)</label>
                                                        <input type="text" className="form-control form-control-sm"
                                                            id="senderEmail" placeholder="Email address"
                                                            name="senderEmail"
                                                            onChange={(e) => onSenderEmailChange(e.target.value)} />
                                                        <p className='error'>{senderEmailError.length > 0 && senderEmailError}</p>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Message (optional)</label>
                                                        <textarea name="message" rows={8} cols={60}
                                                            className="avnet-textBox form-control h-auto"
                                                            placeholder="Message"
                                                            onChange={(e) => onMessageChange(e.target.value)} />
                                                        <p className='error'>{messageError.length > 0 && messageError}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                            {/* Modal footer */}
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">
                                    <button type="button" className="bs5 btn btn-secondary w145"
                                        onClick={() => {
                                            onHide()
                                        }}>
                                        CANCEL
                                    </button>
                                    {export_type && bom_detail_by_bom_id_type.downloadColumnList && Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length > 0 &&
                                        <>
                                            {DownloadBomPopup && DownloadBomPopup.data && DownloadBomPopup.data.isEmailPopup === 'yes' ?
                                                <button type="button" className="bs5 btn btn-primary w145"
                                                    onClick={async (e) => {
                                                        __check('BOM_EMAIL_API_CALL').status ? e.preventDefault() :
                                                            await downloadFile(DownloadBomPopup.data.isEmailPopup)
                                                    }}
                                                >
                                                    {__check('BOM_EMAIL_API_CALL').status ?
                                                        <i className="fa fa-spinner fa-spin" /> :
                                                        'share'
                                                    }
                                                </button>
                                                :
                                                <button type="button" className="bs5 btn btn-primary w145"
                                                    onClick={async (e) => {
                                                        __check('BOM_DOWNLOAD_API_CALL').status ? e.preventDefault() :
                                                            await downloadFile()

                                                        /**
                                                         * Set Events and Evars as per basav comment (14664)
                                                         * Author: Devanshi Patel
                                                         */

                                                        if (window?.digitalData) {
                                                            window.digitalData.event.eventinfo.events = "BOM Download clicked";
                                                        }

                                                    }}
                                                >
                                                    {__check('BOM_DOWNLOAD_API_CALL').status ?
                                                        <i className="fa fa-spinner fa-spin" /> : 'download'
                                                    }
                                                </button>

                                            }
                                        </>

                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Modal>
        </>
    )
}

export default DownloadBomPopup;